// recon-vat-messages translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'rcv.flag.duplicate': 'Mulig duplikatbilag',
  'rcv.flag.salesWithoutDoc': 'Salg uten MVA krever dokumentasjon',
  'rcv.flag.creditNote': 'Kreditnota — kontroller periodisering',
  'rcv.item.customer': 'Kunde',
  'rcv.item.otherSale': 'Annet salg',
  'rcv.item.purchase': 'Kjøp',
  'rcv.check.registered': 'Virksomheten er MVA-registrert for perioden',
  'rcv.check.treatment': 'Alle transaksjoner har fastsatt avgiftsbehandling',
  'rcv.check.outgoing': 'Utgående MVA i hovedboken stemmer med MVA-kodene',
  'rcv.check.incoming': 'Inngående MVA i hovedboken stemmer med MVA-kodene',
  'rcv.check.direct': 'Direkteføringer på MVA-kontoene er identifisert',
  'rcv.check.duplicates': 'Mulige duplikater er identifisert',
  'rcv.check.deduction': 'Kjøp med begrenset fradragsrett er identifisert',
  'rcv.check.reverse': 'Omvendt avgiftsplikt er identifisert',
  'rcv.check.import': 'Vareimport har tolldeklarasjon',
  'rcv.check.exempt': 'Salg uten MVA er identifisert',
  'rcv.check.credit': 'Kreditnotaer i perioden er identifisert',
  'rcv.check.settlement': 'Oppgjørskontoen er nullstilt fra forrige termin',
  'rcv.check.filed': 'MVA-meldingen for terminen er levert',
  'rcv.src.ledger': 'Hovedbok',
  'rcv.src.sales': 'Bokførte salgsbilag',
  'rcv.src.purchases': 'Bokførte kjøpsbilag',
  'rcv.src.spec': 'MVA-spesifikasjon',
  'rcv.src.customs': 'Tolldeklarasjoner',
  'rcv.src.filing': 'MVA-melding for terminen',
  'rcv.src.payment': 'Betaling og oppgjør',
  'rcv.src.ledgerDetail': '{count} posteringer på MVA-kontoene i perioden',
  'rcv.src.linesDetail': '{count} linjer i perioden',
  'rcv.src.specDetail': '{count} MVA-koder med beløp',
  'rcv.src.customsDetail': '{registered} registrert · {missing} mangler',
  'rcv.src.filingDetail': '{period} · frist {due}',
  'rcv.src.noTerm': 'Ingen termin funnet',
  'rcv.src.paymentDetail': '{count} betaling(er) registrert',
  'rcv.main.salesBasisNote': 'Grunnlaget ligger på inntektskontoene, ikke på en MVA-konto.',
  'rcv.main.net': 'Netto MVA for terminen',
});
